import { render, staticRenderFns } from "./ProductPhotos.vue?vue&type=template&id=417884fa&scoped=true&"
import script from "./ProductPhotos.vue?vue&type=script&lang=js&"
export * from "./ProductPhotos.vue?vue&type=script&lang=js&"
import style0 from "./ProductPhotos.vue?vue&type=style&index=0&id=417884fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417884fa",
  null
  
)

export default component.exports